module.exports = __webpack_public_path__ + "files/4a1f727b297194a8a04f77e017a7322e.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-2.png
// module id = 520
// module chunks = 76